export const GET_TRANSACTION_HISTORY = "GET_TRANSACTION_HISTORY"
export const GET_TRANSACTION_HISTORY_ERR = "GET_TRANSACTION_HISTORY_ERR"

export const CLEAR_TRANSACTION_HISTORY = "CLEAR_TRANSACTION_HISTORY" 